//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import { AccountService } from "@nuskin/ns-account";
import {
  events,
  StoreFrontSponsorStorageService,
  PersonalOfferStorageService
} from "@nuskin/ns-util";
import { isNullOrEmpty } from "@nuskin/ns-common-lib";
import { NsIcon } from "@nuskin/ns-icon";
import { MySiteRestService } from "@nuskin/my-site-api";

import NsLogo from "./NsLogo.vue";
import vueEventBus from "./EventBus";

export default {
  name: "NsFooterStorefront",
  components: { NsIcon, NsLogo },
  props: {
    storefront: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    distributor: {}
  }),
  computed: {
    baseUrl() {
      return this.$NsAppService.runConfig.baseUrl || "";
    },
    marketConfig() {
      return this.$NsAppService.marketConfig;
    },
    awsUrl() {
      return this.$NsAppService.awsUrl;
    }
  },
  mounted() {
    this.addListeners();
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    async getStoreOwnerId(subdomain) {
      const url = `${this.awsUrl}/ns-share-api/v1/my-site/subdomain/${subdomain}`;
      const response = await axios.get(url, {
        headers: this.getRequestHeaders()
      });
      return ((response || {}).data || {}).subdomainOwner;
    },

    async getStoreOwnerData(userId) {
      const url = `${this.awsUrl}/ns-share-api/v1/my-site/sponsor/${userId}`;
      const response = await axios.get(url, {
        headers: this.getRequestHeaders()
      });
      return ((response || {}).data || {}).sponsor;
    },

    getUrlParam(name) {
      const params = new URLSearchParams(window.location.search);
      return params.get(name);
    },

    async handleStorefront() {
      if (this.$NsAppService.loading) {
        return;
      }

      if (PersonalOfferStorageService.isPersonalOffer()) {
        await this.setStorefrontDataFromPersonalOffer();
        return;
      }

      // If not personal-offer, get userId and data via storage or axios
      const subdomain = await MySiteRestService.getCurrentSubdomain();
      const userId = await this.getStoreOwnerId(subdomain);
      if (!userId) {
        console.error("Couldn't find distributor id.");
        return;
      }

      const { data: sponsorFromStorage } =
        StoreFrontSponsorStorageService.getStoreFrontSponsor() || {};

      // use session storage if the correct sponsor is saved there, before using service
      let sponsor;
      if (sponsorFromStorage && sponsorFromStorage.sapId === userId) {
        sponsor = sponsorFromStorage;
      } else {
        sponsor = await this.getStoreOwnerData(userId);
      }

      await this.setStorefrontData(sponsor);
    },

    async setStorefrontDataFromPersonalOffer() {
      // get previous pageName if referred
      let userId = this.getUrlParam("userId");
      if (!userId) {
        const poData = PersonalOfferStorageService.getPersonalOffer();
        if (poData) {
          userId = poData.sapId;
        }
      }

      if (document.referrer) {
        const prevPage = document.referrer.split("/");
        const pageName = prevPage[prevPage.length - 1];
        const prevPageName = pageName.substring(0, pageName.indexOf("."));

        // use storefront storage if "checkout" or "product"
        if (prevPageName === "checkout" || prevPageName === "product") {
          const {
            data: sponsorFromStorage
          } = StoreFrontSponsorStorageService.getStoreFrontSponsor();
          if (sponsorFromStorage) {
            await this.setStorefrontData(sponsorFromStorage);
            return;
          }
        }
      }

      const sponsor = await this.getStoreOwnerData(userId);
      await this.setStorefrontData(sponsor);
    },

    async setStorefrontData(sponsor) {
      // bad sponsor data can return as an empty object
      if (isNullOrEmpty(sponsor)) {
        console.error("Couldn't find distributor data.");
        return;
      }

      const isPersonalOffer = PersonalOfferStorageService.isPersonalOffer();
      let distImageUrl = isPersonalOffer
        ? sponsor.photoURL || sponsor.profilePhoto
        : sponsor.profilePhoto || sponsor.photoURL;
      // make sure footer never uses default black mysite logo, fallaback to NsLogo default
      distImageUrl = distImageUrl.includes("/content/dam/icons/logos/logo.png")
        ? ""
        : distImageUrl;

      const displayName = await StoreFrontSponsorStorageService.getDisplayName({
        getAccountInfo: AccountService.getAccountInfo,
        userId: sponsor.sapId
      });

      const distImageUrlVal = distImageUrl.startsWith("/")
        ? this.baseUrl + distImageUrl
        : distImageUrl;
      this.distributor = {
        distImage: distImageUrl ? distImageUrlVal : "",
        distName: displayName || "",
        distEmail: sponsor.email,
        distPhone: sponsor.phone,
        distSocialMedia: (sponsor.socialAccounts || []).map(link => ({
          href: !link.url.includes("http") ? `https://${link.url}` : link.url,
          iconName: `icon-${link.id}`,
          label: link.name
        }))
      };
    },

    /**
     * Returns headers to call lambda
     * @returns {{Content-Type: string, client_id: string, client_secret: string}}
     * @private
     */
    getRequestHeaders() {
      return {
        "Content-Type": "application/json",
        client_id: this.marketConfig.checkout.clientId,
        client_secret: this.marketConfig.checkout.clientSecret
      };
    },

    /**
     * Subscribe to events, should only be called when mounted
     */
    addListeners() {
      this.$watch(
        function() {
          return !this.$NsAppService.loading;
        },
        this.handleStorefront,
        {
          immediate: true
        }
      );

      events.subscribe(
        events.shop.PERSONAL_OFFER_LOADED,
        this.handleStorefront
      );

      vueEventBus.$on("config-changed", this.handleStorefront);
    },

    /**
     * Unsubscribe from events, should only be called when destroyed
     */
    removeListeners() {
      events.unsubscribe(
        events.shop.PERSONAL_OFFER_LOADED,
        this.handleStorefront
      );

      vueEventBus.$off();
    }
  }
};
